document.addEventListener('DOMContentLoaded', function () {
  function checkSelectedVariantInventory(input) {
    if (!input) return;

    var selectedSize = input.value;
    var qty = parseInt(window.inventory_details[selectedSize]);

    if (qty <= window.few_left_threshold && qty > 0) {
      console.log(window.few_left_text);
    } else if (qty > window.few_left_threshold) {
      console.log('In Stock');
    } else {
      console.log('Out of Stock');
    }
  }

  document.querySelectorAll('input[name="Size"]').forEach(function (input) {
    if (input.checked) {
      checkSelectedVariantInventory(input);
    }

    input.addEventListener('change', function () {
      checkSelectedVariantInventory(this);
    });
  });
});
